(() => {
  const selector = '[data-msp-manufacturer-products]';

  function initialize(section) {
    if (!section || section.dataset.mspProductsInitialized === 'true') return;

    const items = [...section.querySelectorAll('[data-msp-manufacturer-product]')];
    const initialVisible = Number.parseInt(section.dataset.initialVisibleProducts, 10) || 8;
    const extraItems = items.slice(initialVisible);
    const reveal = section.querySelector('[data-msp-manufacturer-products-reveal]');
    const button = section.querySelector('[data-msp-manufacturer-products-button]');

    if (!extraItems.length || !reveal || !button) return;

    extraItems.forEach((item) => {
      item.hidden = true;
    });
    reveal.hidden = false;
    section.dataset.mspProductsInitialized = 'true';

    button.addEventListener('click', () => {
      extraItems.forEach((item) => {
        item.hidden = false;
      });
      button.setAttribute('aria-expanded', 'true');
      reveal.hidden = true;

      const firstProductLink = extraItems[0]?.querySelector('a[href]');
      firstProductLink?.focus({ preventScroll: true });
    });
  }

  function initializeAll(root = document) {
    if (root.matches?.(selector)) initialize(root);
    root.querySelectorAll?.(selector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('[data-msp-manufacturer-product]');
    if (item) item.hidden = false;
  });
})();
